<input [(ngModel)]="date" class="search-bar regular" #datepicker>